// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Browser from "@rugby/XDL/Utilities/Browser";
import color from "@rugby/XDL/Utilities/color";
import contrastColor from "@rugby/XDL/Utilities/contrastColor";
import ellipsis from "@rugby/XDL/Utilities/ellipsis";
import EventBus from "@rugby/XDL/Utilities/EventBus";
import hexToRGB from "@rugby/XDL/Utilities/hexToRgba";
import CustomMediaQuery, { MediaQuery } from "@rugby/XDL/Utilities/MediaQuery";
import { detectIsAuthenticated } from "@rugby/XDL/Utilities/utilities";

export const isMobileDevice = () => {
    if (typeof window !== "undefined") {
        return window.matchMedia("(max-width: 768px) and (hover: none)").matches;
    }
    return false;
};

export const isTabletDevice = () => {
    if (typeof window !== "undefined") {
        return window.matchMedia("(max-width: 1024px)").matches;
    }
    return false;
};

export const capitalize = (text: string) => {
    return text.toLowerCase().replace(/\b./g, (a: string) => {
        return a.toUpperCase();
    });
};

export const maybePluralize = (count: number, noun: string, suffix = "s", showCount = true, showZeroCount = false) => {
    let message = "";
    if (showCount) {
        message = (count === 0 && showZeroCount) || count > 0 ? `${count} ` : "";
    }
    return `${message}${noun}${count > 1 ? suffix : ""}`;
};

export {
    hexToRGB,
    color,
    contrastColor,
    ellipsis,
    Browser,
    CustomMediaQuery,
    MediaQuery,
    EventBus,
    detectIsAuthenticated,
};
